import { notifyRef } from "../components/refs";

const ENDPOINT = "https://safe-reef-74759.herokuapp.com"
// const ENDPOINT = "http://localhost:3300"

const ENDPOINTGO = "http://192.168.43.79:3300"
const MINLENGHTPROBLEM = 30
const CLOUDINARYURL = "https://res.cloudinary.com/rupamcloud"
// @dev
const NetworkCall = (timeout) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, timeout);
    })
}
//


let sync = setTimeout(() => { }, 0)
const ShowNotification = (text, color, timeout, kill) => {
    // makeDraggable('notif')
    document.getElementById('notif-text').innerHTML = ''
    notifyRef.current.style.display = 'none'
    clearTimeout(sync)
    notifyRef.current.style.display = 'flex'
    document.getElementById('notif-text').innerHTML = text
    document.getElementById('notif-text').style.color = color
    if (timeout >= 0)
        sync = setTimeout(() => {
            document.getElementById('notif-text').innerHTML = ''
            notifyRef.current.style.display = 'none'

        }, timeout);
}

const makeDraggable = (id) => {
    document.getElementById(id).style.position = 'absolute'
    // document.getElementById(id).style.removeProperty('bottom')
    dragElement(document.getElementById(id));
    function dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id)) {
            /* if present, the id is where you move the DIV from:*/
            document.getElementById(elmnt.id).onmousedown = dragMouseDown;
        } else {
            /* otherwise, move the DIV from anywhere inside the DIV:*/
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }
}




export { ENDPOINT, ENDPOINTGO, NetworkCall, ShowNotification, makeDraggable, MINLENGHTPROBLEM, CLOUDINARYURL }